module.exports = __webpack_public_path__ + "static/img/login-background.f9f49138.jpg";